import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookF, faInstagram, faLinkedin, faTiktok, faTwitter, faYoutube} from "@fortawesome/free-brands-svg-icons";
import React from "react";
import Security from "./security";
import {faUserCog} from "@fortawesome/pro-solid-svg-icons";
import {Post} from "./request";

export default function Social() {

    const changeStudentUser = async (e) => {
        e.preventDefault();

        let matricule = window.prompt("Veuillez introduire le nouveau matricule");

        if (matricule !== null && matricule !== "") {
            await Post(`/v1/security/matricule/${matricule}`);
            window.location.href = window.origin + process.env.APP_ROOT;
        }
    }

    return <div>
        <div className="social">
            <a className={"text-white pr-2"}
               href={process.env.APP_DEPARTEMENT === "ISFSC" ? "https://isfsc.be/politique-de-vie-privee/" : "https://files.ichec.be/ICHEC-Student-Vie-Privee.html"}
               target="_blank"
               rel="noopener noreferrer">
                <small>Politique de vie privée</small>
            </a>
            <a href={"https://www.facebook.com/" + (process.env.APP_DEPARTEMENT === "ISFSC" ? "haute.ecole.isfsc/" : "ICHEC.Brussels.Management.School/")}
               target="_blank"
               rel="noopener noreferrer">
                <FontAwesomeIcon className="fa-fw" icon={faFacebookF}/>
            </a>
            <a href={process.env.APP_DEPARTEMENT === "ISFSC" ? "https://www.tiktok.com/@isfsc" : "https://twitter.com/IchecBrussels"}
               target="_blank"
               rel="noopener noreferrer">
                <FontAwesomeIcon className="fa-fw" icon={process.env.APP_DEPARTEMENT === "ISFSC" ? faTiktok : faTwitter}/>
            </a>
            <a href={"https://www.linkedin.com/" + (process.env.APP_DEPARTEMENT === "ISFSC" ? "school/isfsc/" : "company/ichec/")}
               target="_blank"
               rel="noopener noreferrer">
                <FontAwesomeIcon className="fa-fw" icon={faLinkedin}/>
            </a>
            <a href={"https://www.instagram.com/" + (process.env.APP_DEPARTEMENT === "ISFSC" ? "isfsc/" : "ichec.brussels/")}
               target="_blank"
               rel="noopener noreferrer">
                <FontAwesomeIcon className="fa-fw" icon={faInstagram}/>
            </a>
            <a href={"https://www.youtube.com/channel/" + (process.env.APP_DEPARTEMENT ==="ISFSC" ? "UCc7Rntp1uPQLdU-Jm49eKag" : "UCG9stSs0SzxapWXmIIxua0g")}
               target="_blank"
               rel="noopener noreferrer">
                <FontAwesomeIcon className="fa-fw" icon={faYoutube}/>
            </a>
            {Security.isAuthenticated() && (Security.getUser().ICHECAdmin === true || Security.getUser().ICHECProgrammes === true)
                ?
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a href="#"
                   style={{textDecoration: "none"}}
                   onClick={changeStudentUser.bind(this)}>
                    <FontAwesomeIcon className="text-white fa-fw" icon={faUserCog}/>
                    <span className={"text-white"}> <b>{Security.getUser().EtudiantMatricule}</b></span>
                </a>
                : ""}

        </div>
    </div>;
}